import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';

// core components
import PagesHeader from 'components/Header/PagesHeader';

import authStyle from 'layouts/style/authStyle';
import getRoutes from 'routes/components';

class AuthLayout extends Component {
  render() {
    const { classes, ...rest } = this.props;
    localStorage.clear();
    return (
      <div>
        <PagesHeader {...rest} color='whiteColor' />
        <div className={classes.wrapper}>
          <div className={classes.fullPage}>
            {getRoutes('auth')}
            <div className={classes.fullPageBackground} />
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(authStyle)(AuthLayout);
